import { useSelector } from '../../../../Flux/index.js'
import { selectSourceCubeRefs } from '../../../../Flux/Slice/Visualization/Selectors.js'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'

/**
 * Explicit "downloading the cube" indicator for the workspace header. The cube fetch can take a
 * while on large scopes; before this, the only feedback was per-sink spinners that look identical
 * to "no data". Shows whenever any source's `(scopeId, blastType)` cube is still `loading`.
 */
export default function CubeLoadingBadge() {
  const loadingCount = useSelector((s) => selectSourceCubeRefs(s).filter((r) => r.status === 'loading').length)

  if (loadingCount === 0) return null

  return (
    <div className="badge badge-info gap-2 py-3" role="status" aria-live="polite">
      <span className="loading loading-spinner loading-xs" />
      <ArrowDownTrayIcon className="w-4 h-4" />
      <span>Loading data{loadingCount > 1 ? ` (${loadingCount})` : ''}…</span>
    </div>
  )
}
